import { render, staticRenderFns } from "./tabs-assignment.vue?vue&type=template&id=12098c62&scoped=true&"
import script from "./tabs-assignment.vue?vue&type=script&lang=js&"
export * from "./tabs-assignment.vue?vue&type=script&lang=js&"
import style0 from "./tabs-assignment.vue?vue&type=style&index=0&id=12098c62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12098c62",
  null
  
)

export default component.exports